import AbstractRepository from "@/repositories/AbstractRepository";

export default class OwnerAttributeDefinitionRepository extends AbstractRepository {
    protected static resource: string = "ownerattributedefinition";

    protected static defaultFields: string[] = [
        "uuid",
        "attribute.uuid",
        "attribute.label",
        "attribute.type",
        "rank",
        "visible",
        "module",
        "description",
        "creativeTags",
        "defaultValue",
    ];
}
